
import jqueryUrl from '../assets/js/jquery.min.js?url';
import bootstrapUrl from '../assets/js/bootstrap.min.js?url';

declare global {
  interface Window {
    jQuery: any;
    $: any;
    bootstrap: any;
  }
}

export const loadScripts = () => {
  return new Promise((resolve, reject) => {
    if (window.jQuery) {
      loadBootstrap().then(resolve).catch(reject);
      return;
    }

    const jqueryScript = document.createElement('script');
    jqueryScript.src = jqueryUrl;
    jqueryScript.onload = () => {
      window.$ = window.jQuery;
      loadBootstrap().then(resolve).catch(reject);
    };
    jqueryScript.onerror = () => reject(new Error('Failed to load jQuery'));
    document.head.appendChild(jqueryScript);
  });
};

const loadBootstrap = () => {
  return new Promise((resolve, reject) => {
    if (window.bootstrap) {
      resolve(void 0);
      return;
    }

    const bootstrapScript = document.createElement('script');
    bootstrapScript.src = bootstrapUrl;
    bootstrapScript.onload = () => resolve(void 0);
    bootstrapScript.onerror = () => reject(new Error('Failed to load Bootstrap'));
    document.head.appendChild(bootstrapScript);
  });
};

